import _ from 'lodash'
import templateUrl from './parcel.view.html'

/**
 * Parcel detail Report route
 *
 * @namespace routes.ReportParcelView
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.parcels.view',
  label: 'REPORT.PARCELS.VIEW.TITLE',
  component: 'tmrReportParcelView',
  accessControl: 'TmrShippingOperationsLegacyAccessControl',
  data: {
    capabilities: ['Resource.view', 'Resource.Parcel.view'],
  },
  abstract: false,
}

/**
 * Component for {@link routes.tmrReportParcelView Parcels Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportParcelView = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrReportParcelViewController',
  bindings: {
    resource: '<',
    resourceListTitle: '<?',
    resourceListSref: '@?',
    drilldown: '<?',
  },
}

/**
 * Controller of component {@link tmrReportParcelView}.
 *
 * @type {ngController}
 */
export class tmrReportParcelViewController {
  static ngType = 'controller'

  constructor($mdDialog, TmrMovementHelper, Item, Product) {
    'ngInject'
    Object.assign(this, { $mdDialog, TmrMovementHelper, Item, Product })
  }

  $onInit() {
    this.initVars()
    this.details = [
      { label: 'REPORT.PARCELS.VIEW.CODE', value: this.resource.code },
      { label: 'REPORT.PARCELS.VIEW.ASN', value: this.resource.asn.code },
      {
        label: 'REPORT.PARCELS.VIEW.CREATED',
        value: this.resource.creationDate,
        filter: 'tmrDate',
      },
    ]
    if (this.resource.receivingDate) {
      this.details.push({
        label: 'REPORT.PARCELS.VIEW.RECEIVED',
        value: this.resource.receivingDate,
        filter: 'tmrDate',
      })
    }
  }

  initVars() {
    this.itemsByExpectedUpc = []
    this.buildGroups()
  }

  /**
   * Groups read items by upc + unexpected.
   * Fakes data read from an antenna, like in {@link tmrOperationInboundController}
   */
  buildGroups() {
    let fakeDetails = _.keyBy(this.resource.parcelItems, 'item.epc')
    let detectedItems = this.resource.parcelItems
      .filter(item => item.detected)
      .map(item => item.item)
    let fakeAntenna = {
      $epcs: detectedItems.map(item => item.epc),
      $itemsByEpc: _.keyBy(
        detectedItems.map(item => this.Item.create(item)),
        'epc'
      ),
      $products: _.keyBy(
        detectedItems.map(item => this.Product.create(item.product)),
        'code'
      ),
    }
    let expected = this.resource.parcelItems
      .filter(item => !item.unexpected)
      .map(item => item.item)
    this.itemsByExpectedUpc = this.TmrMovementHelper.groupitemsByExpectedUpc(
      fakeDetails,
      fakeAntenna,
      expected
    )
    this.itemsCount = this.TmrMovementHelper.countItems(this.itemsByExpectedUpc)
  }
}
